module.exports = __webpack_public_path__ + "static/media/groomsmen-main.b3a2482e.jpg";